import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { ResendIdentityVerificationEmailMutationResponse } from "../types/ResendIdentityVerificationEmail";
import type { UseMutationOptions } from "@tanstack/react-query";

 type ResendIdentityVerificationEmailClient = typeof client<ResendIdentityVerificationEmailMutationResponse, never, never>;
type ResendIdentityVerificationEmail = {
    data: ResendIdentityVerificationEmailMutationResponse;
    error: never;
    request: never;
    pathParams: never;
    queryParams: never;
    headerParams: never;
    response: ResendIdentityVerificationEmailMutationResponse;
    client: {
        parameters: Partial<Parameters<ResendIdentityVerificationEmailClient>[0]>;
        return: Awaited<ReturnType<ResendIdentityVerificationEmailClient>>;
    };
};
/**
 * @link /api/identity/resend-verification-email
 */
export function useResendIdentityVerificationEmail(options: {
    mutation?: UseMutationOptions<ResendIdentityVerificationEmail["response"], ResendIdentityVerificationEmail["error"], ResendIdentityVerificationEmail["request"]>;
    client?: ResendIdentityVerificationEmail["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async () => {
            const res = await client<ResendIdentityVerificationEmail["data"], ResendIdentityVerificationEmail["error"], ResendIdentityVerificationEmail["request"]>({
                method: "post",
                url: `/api/identity/resend-verification-email`,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}